import { Outlet } from "react-router-dom";

const CarRental = () => {
  return (
    <><Outlet /></>
  );
};

export default CarRental;